module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/5@2x_b5607b2839cc7d27583a6c6f40eb904b.png";